import HttpService from '../base.service/HttpService'

export default class SpkluService extends HttpService {
  getLocationSpklu (param) {
    const api = process.env.VUE_APP_API + '/dashboardSpklu/lokasiSpklu'
    return this.get(param, api)
  }

  getProyeksiSpklu (param) {
    const api = process.env.VUE_APP_API + '/dashboardSpklu/proyeksiSpklu'
    return this.get(param, api)
  }

  getDataKordinatById (param, id) {
    const api = process.env.VUE_APP_API + `/dashboardSpklu/proyeksiSpklu/${id}`
    return this.get(param, api)
  }

  putDataKordinat (param, id) {
    const api = process.env.VUE_APP_API + `/dashboardSpklu/proyeksiSpklu/${id}`
    return this.put(param, api)
  }

  getCordinatesHC (param) {
    const api = process.env.VUE_APP_API + '/dashboardSpklu/HomeCharging/map'
    return this.get(param, api)
  }

  getDetailAvailabilitySpklu (param) {
    const api = process.env.VUE_APP_API + '/dashboardSpklu/availabilitySpklu'
    return this.get(param, api)
  }

  getLocationCard (param) {
    const api = process.env.VUE_APP_API + '/dashboardSpklu/cardLokasiSpklu'
    return this.get(param, api)
  }

  getAvabilityCard (param) {
    const api =
      process.env.VUE_APP_API + '/dashboardSpklu/cardAvailabilitySpklu'
    return this.get(param, api)
  }

  getDetailTransacation (param) {
    const api = process.env.VUE_APP_API + '/dashboardSpklu/detail-transaksi'
    return this.get(param, api)
  }

  getDetailTransacationExcell (param) {
    const api =
      process.env.VUE_APP_API + '/dashboardSpklu/export-detail-transaksi'
    return this.getFile(param, api, param.name)
  }

  getDilSpkluExcell (param) {
    const api =
      process.env.VUE_APP_API + '/dashboardSpklu/exportIntegrasiSpklu'
    return this.getFile(param, api, param.name)
  }

  getDetailTransaktionCard (param) {
    const api =
      process.env.VUE_APP_API + '/dashboardSpklu/summary-detail-transaksi'
    return this.get(param, api)
  }

  getDilSpklu (param) {
    const api = process.env.VUE_APP_API + '/dashboardSpklu/integrasiSpklu'
    return this.get(param, api)
  }

  getDilSpkluChart (param) {
    const api = process.env.VUE_APP_API + '/dashboardSpklu/chartIntegrasiSpklu'
    return this.get(param, api)
  }

  getRekapIntegrasiSpklu (param) {
    const api = process.env.VUE_APP_API + '/dashboardSpklu/rekapIntegrasiSpklu'
    return this.get(param, api)
  }
}
